module.exports = __webpack_public_path__ + "static/media/Maria_Whitley.4688a7cb.png";